export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ../~/rc-pagination/es/index.js
// module id = 1992
// module chunks = 1